import React, {  Component } from 'react';
import { connect } from 'react-redux';

class ChangeADCBoxTruckLessThanSixteenDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false,
            deliveryMethodError: '',
            deliveryMethod: '',
        }
        this.handleYes = this.handleYes.bind(this);
    }
    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
        this.props.handleDialog('ChangeADCBoxTruckLessThanSixteenDialog');
    }
    componentDidMount() {
        // window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }
    handleYes(e) {
        e.preventDefault();
        const { deliveryMethod } = this.state;
        if(deliveryMethod === 'ADC Box Truck'){
            this.props.continueADCBoxTruck(deliveryMethod);
        } else if (deliveryMethod && deliveryMethod !== 'ADC Box Truck') {
            this.props.continueDeliveryWith(deliveryMethod);
        } else {
            this.setState({
                deliveryMethodError: 'Please select delivery method'
            });
        }
    }
    onChangeUpdateParam(e) {
        this.setState({
            deliveryMethodError: '',
            deliveryMethod: e.target.value
        });
    }
    render() {
        const self = this;
        const { deliveryMethodError } = self.state;
        let { shippingMethodList } = self.props;
        if(this.props.removeADCBoxTruck){
            shippingMethodList = shippingMethodList.filter(item => item.label !== "ADC Box Truck");
        }
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="ChangeADCBoxTruckLessThanSixteenDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Change Shipping Method</h2>
                    <p>Your order doesn&#39;t have enough points to qualify for ADC Box Truck shipment.</p>
                    <p><b>Would you like to continue another shipping method? Additional charges may apply.</b></p>
                     {deliveryMethodError && <p className="red">{this.state.deliveryMethodError}</p>}
                    <table className="formTableTypeA">
						<tbody>
                            {shippingMethodList.map((item, index) => {
                                if (item.label === 'ADC Truckload') return null;
                                return (
                                    <tr key={index}>
                                        <td>
                                            <input type="radio" name="deliveryMethod" id={`deliveryMethod${index}`} onClick={self.onChangeUpdateParam.bind(this)} value={item.value} />
                                        </td>
                                        <td>
                                            <label htmlFor={`deliveryMethod${index}`}><strong>{item.label}</strong></label>
                                        </td>
                                    </tr>
                                );
                            })}
						</tbody>
					</table>
                    <div className="noButtonContainer">
                        <a onClick={(e) => this.props.continueDeliveryWith(false, e)} href="" className="noButton blueButton">No</a>
                    </div>
                    <div className="yesButtonContainer">
                        <a className="yesButton blueButton" onClick={this.handleYes}>Yes</a>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
   return {state};
};

ChangeADCBoxTruckLessThanSixteenDialog = connect(mapStateToProps)(ChangeADCBoxTruckLessThanSixteenDialog);
export default ChangeADCBoxTruckLessThanSixteenDialog;



// WEBPACK FOOTER //
// ./src/App/components/dialogs/changeADCBoxTruckLessThanSixteenDialog.js